import { Modal, Button } from "react-bootstrap";

const DeliveryPartnerPrivacyPolicyModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Flavchap.com - Delivery Partner Privacy Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p><strong>Last Updated: </strong>{process.env.REACT_APP_DELIVERY_PRIVACY_UPDATE_DATE}</p>
        <h5>Hello Partner!</h5>
        <p>
          Welcome to <strong>flavchap.com</strong> (“flavchap”, “we”, “us”, or “our”). This Privacy Policy explains how we collect, use, disclose, and protect your personal information as a delivery partner (“you”, “your”). By partnering with us or using our delivery partner systems, you agree to the practices described below.
        </p>

        <h6>1. Information We Collect</h6>
        <p>
          We collect information necessary for managing your partnership and ensuring safe and efficient operations. This may include:
          <ul>
            <li><strong>Personal Information:</strong> Name, contact number, address, and email.</li>
            <li><strong>Identity Documents:</strong> Government-issued ID, driver’s license, and vehicle registration.</li>
            <li><strong>Bank Details:</strong> For processing partner payments and incentives.</li>
            <li><strong>Location Data:</strong> Real-time GPS tracking during active deliveries to assist order routing and safety monitoring.</li>
            <li><strong>Device Information:</strong> Mobile device type, OS version, and network details for technical support and fraud prevention.</li>
          </ul>
        </p>

        <h6>2. How We Use Your Information</h6>
        <p>
          We use your information to:
          <ul>
            <li>Verify identity and onboard you as a delivery partner.</li>
            <li>Assign delivery orders and track delivery progress in real time.</li>
            <li>Process payments, bonuses, and incentives.</li>
            <li>Communicate schedules, updates, and operational instructions.</li>
            <li>Ensure customer and partner safety, and prevent misuse or fraud.</li>
            <li>Comply with legal, tax, and regulatory obligations.</li>
          </ul>
        </p>

        <h6>3. How We Share Your Information</h6>
        <p>
          Your information is shared only as needed to operate our service effectively:
          <ul>
            <li><strong>Internal Teams:</strong> For order management, support, and payment processing.</li>
            <li><strong>Payment Gateways:</strong> To facilitate secure transactions.</li>
            <li><strong>Technology Providers:</strong> For hosting, routing, and tracking functionalities.</li>
            <li><strong>Legal Authorities:</strong> When required by applicable law or court order.</li>
          </ul>
          We do not sell or rent partner data to third parties.
        </p>

        <h6>4. Data Retention</h6>
        <p>
          We retain your information only as long as necessary for operational, legal, and accounting purposes. Once your partnership ends, relevant data will be deleted or anonymized within a reasonable timeframe, unless required by law to be retained longer.
        </p>

        <h6>5. Data Security</h6>
        <p>
          Flavchap employs administrative, technical, and physical safeguards to protect your data from unauthorized access, loss, or misuse. These include encryption, secure servers, and restricted access for authorized personnel only.
        </p>

        <h6>6. Location Tracking</h6>
        <p>
          Real-time location tracking is active only during assigned deliveries. It is used solely for order management, route optimization, and safety. Tracking automatically stops once you mark the delivery as complete.
        </p>

        <h6>7. Your Rights</h6>
        <p>
          You may request to:
          <ul>
            <li>Access or correct your personal data.</li>
            <li>Withdraw consent for marketing communications.</li>
            <li>Request deletion of your information after ending your engagement.</li>
          </ul>
          For such requests, contact <strong>info@ncgglobalenterprises.com</strong>.
        </p>

        <h6>8. Use of Partner Apps/Website</h6>
        <p>
          If you access Flavchap systems or partner applications or website, your login and usage information may be recorded to maintain system integrity and performance. Please do not share your login credentials with anyone.
        </p>

        <h6>9. Changes to This Policy</h6>
        <p>
          Flavchap may update this Privacy Policy periodically. The revised version will be posted on our website, and continued use of our services implies your acceptance of the updated terms.
        </p>

        <h6>10. Contact Us</h6>
        <p>
          For questions or privacy-related concerns, reach out to:
          <br />
          📧 <strong>info@ncgglobalenterprises.com</strong>
          <br />
          🌐 <strong>www.flavchap.com</strong>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeliveryPartnerPrivacyPolicyModal;